/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Site_QInputs */

const en_wc_faq_site_q = /** @type {(inputs: Wc_Faq_Site_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What can I do on WordCraftApp?`)
};

/**
* | output |
* | --- |
* | "What can I do on WordCraftApp?" |
*
* @param {Wc_Faq_Site_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_site_q = /** @type {((inputs?: Wc_Faq_Site_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Site_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_site_q(inputs)
});
export { wc_faq_site_q as "wc.faq.site.q" }